import p from 'pluralize';

export const pluralize = (word: string, count: number, inclusive?: boolean) => p(word, count, inclusive);

export const singularize = p.singular;
